import React from 'react';

export default function ResolvedIcon({ width = '20px', height = '20px', flex = 'none' }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <circle cx="9" cy="9" r="8" fill="#24CA49" />
      <g clipPath="url(#clip0_25808_119070)">
        <path d="M11.2467 6.17264C11.014 5.93725 10.6347 5.93428 10.3982 6.16603L5.96322 10.5493L4.03528 8.55341C3.80534 8.31375 3.42466 8.30588 3.18502 8.53583C2.94536 8.76577 2.9375 9.14645 3.16744 9.38608C3.16848 9.38715 3.1695 9.38822 3.17054 9.38929L5.52125 11.8254C5.63375 11.9401 5.7875 12.0051 5.94821 12.0058H5.95483C6.11249 12.0053 6.26367 11.9429 6.37578 11.832L11.2413 7.02115C11.4764 6.78803 11.4788 6.40876 11.2467 6.17264Z" fill="white" />
        <path d="M9.12954 11.8254C9.24175 11.9399 9.39502 12.0048 9.55531 12.0058H9.56193C9.71959 12.0053 9.87077 11.9429 9.98288 11.832L14.8484 7.02119C15.069 6.77286 15.0465 6.39278 14.7981 6.17224C14.573 5.9723 14.2347 5.96967 14.0065 6.16606L9.57334 10.5493L9.41518 10.3852C9.18526 10.1455 8.80458 10.1376 8.56492 10.3676C8.32526 10.5975 8.31737 10.9782 8.54731 11.2178C8.54835 11.2189 8.54939 11.22 8.55044 11.221L9.12954 11.8254Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_25808_119070">
          <rect width="12" height="12" fill="white" transform="translate(3 3)" />
        </clipPath>
      </defs>
    </svg>
  );
}